import { render, staticRenderFns } from "./DeclarationInvoicingDetails.vue?vue&type=template&id=236709be&"
import script from "./DeclarationInvoicingDetails.vue?vue&type=script&lang=js&"
export * from "./DeclarationInvoicingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports